// @ts-nocheck
import React from "react";
import Section from "../components/Section";
import Grid from "../components/Grid";
import ImageWithText from "../components/ImageWithText";
import FAQ from "../components/FAQ";
import Carousel from "../components/Carousel";
import TextBlock from "../components/TextBlock";
import StickySubNav from "../components/StickySubNav";
import VideoBlock from "../components/VideoBlock";
import MultiTabContainer from "../components/MultiTabContainer";
import MediaTile from "../components/MediaTile";
import LinkWrapper from "../components/LinkWrapper";
import ProductTile from "../components/ProductTile";
import RawHTML from "../components/RawHTML";
import QuoteBlock from "../components/QuoteBlock";
import { CustomCollectionTile, ShopifyCollectionTile } from "../components/CollectionTile";
import ContentGrid from "../components/ContentGrid";
import EmailCapture from '../components/EmailCapture/EmailCapture';
import HeroModule from "../components/HeroModule/HeroModule";
import TextPair from "../components/TextPair";
import CategoryRail from "../components/CategoryRail";
import HistoryBlock from "../components/HistoryBlock";
import EditorialCategories from "../components/EditorialCategories";
import Greenhouse from "../components/Greenhouse";
import SocialLinks from "../components/SocialLinks";
import DynamicContentCarousel from "../components/DynamicContentCarousel";
import SubscriptionCard from "../components/SubscriptionCard";
import SearchspringCarousel from "../components/SearchspringCarousel";
import PerformanceRatingChart from "../components/PerformanceRatingChart";
import CouponCode from "../components/CouponCode";
import CTA from "../components/CTA";
import PLPCTARow from "../components/PlpCtaRow";
import ModshopCollectionTile from "../components/ModshopCollectionTile";

const componentMap = {
  carousel: Carousel,
  categoryRail: CategoryRail,
  contentGrid: ContentGrid,
  couponCode: CouponCode,
  customCollectionTile: CustomCollectionTile,
  dynamicContentCarousel: DynamicContentCarousel,
  editorialCategories: EditorialCategories,
  emailCapture: EmailCapture,
  faq: FAQ,
  greenhouse: Greenhouse,
  grid: Grid,
  heroModule: HeroModule,
  historyBlock: HistoryBlock,
  imageWithText: ImageWithText,
  linkWrapper: LinkWrapper,
  mediaTile: MediaTile,
  modshopCollectionTile: ModshopCollectionTile,
  multiTabContainer: MultiTabContainer,
  plpCtaRow: PLPCTARow,
  productTile: ProductTile,
  quoteBlock: QuoteBlock,
  rawHtml: RawHTML,
  section: Section,
  searchspringCarousel: SearchspringCarousel,
  shopifyCollectionTile: ShopifyCollectionTile,
  performanceRatingChart: PerformanceRatingChart,
  socialLinks: SocialLinks,
  stickySubNav: StickySubNav,
  subscriptionCard: SubscriptionCard,
  textBlock: TextBlock,
  textPair: TextPair,
  videoBlock: VideoBlock,
  cta: CTA,
};

const contentfulComponentLoop = (components, props = {}) => {
  const brandDiv = document.getElementById('site-brand-setting');
  const brand = brandDiv?.dataset?.brand || 'fender';
  const jwtDiv = document.getElementById('react-jwt-all');
  const customerId = jwtDiv?.dataset?.customer || '';

  return components?.map(component => {
    const RenderComponent = componentMap[component.sys.contentType.sys.id];

    if (RenderComponent) {
      return (
        <RenderComponent 
          {...component} 
          brand={brand}
          parentProps={props} 
          key={component.sys.id} 
          isAuthenticated={(customerId)}
          id={component.sys.contentType.sys.id}
        />
      );
    }

    return null;
  });
};

export default contentfulComponentLoop;